import React from "react";
import { Skeleton } from 'antd-mobile'

const Loading = () => {
  return (
    <Skeleton.Paragraph />
  )
}

export default Loading;